import { User } from 'CommonScripts/user';
import { RequestService } from './request.service';

export class DomesticCMSService {
    public static async postDomesticCTA(data: any) {
        return await RequestService.post(`${process.env.DOMESTIC_CMS_URL}/process-cta`, { 
            ...data, 
            Source: 'APV',
            AppInstanceGUID: User.getUserId(), 
        });
    }
}